export default "__VITE_ASSET__0db8ce5c__"